const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.803922%,50.588235%,67.843137%)",
      fillOpacity: 1
    },
    d: "M 12 1.332031 L 21.5 6.667969 L 21.5 17.332031 L 12 22.667969 L 2.5 17.332031 L 2.5 6.667969 Z M 5.492188 7.226562 L 12 10.878906 L 18.507812 7.226562 L 12 3.574219 Z M 4.5 8.910156 L 4.5 16.214844 L 11 19.863281 L 11 12.558594 Z M 13 19.863281 L 19.5 16.214844 L 19.5 8.910156 L 13 12.558594 Z M 13 19.863281 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxLine);
export default __webpack_public_path__ + "static/media/box-line.d4f1acedd902bd99e76b1ccd33c1aebd.svg";
export { ForwardRef as ReactComponent };